// @flow
import * as React from 'react';
import { Alert, AlertProps, ButtonBase } from '@mui/material';
import { ComponentProps } from 'react';

export const AlertItem = (props: Omit<AlertProps, 'onClick'> & { onClick: ComponentProps<typeof ButtonBase>['onClick']}) => {
  const {onClick, ...rest} = props;
  return (
    <ButtonBase onClick={onClick} >
      <Alert severity="error" sx={{textAlign: 'left', width: '100%'}} {...rest}>
        {props.children}
      </Alert>
    </ButtonBase>
  );
};
